import { LightningElement, api, wire } from "lwc";
import { c as classNames } from "tds/chunk_index";
import { LabelsAdapter } from "common/labelsAdapter";

var data$9 = { assistive_text: "Fortschritt: %{progress}" };
data$9.assistive_text;

var data$8 = { assistive_text: "Progress: %{progress}" };
data$8.assistive_text;

var data$7 = { assistive_text: "Progreso: %{progress}" };
data$7.assistive_text;

var data$6 = { assistive_text: "Progreso: %{progress}" };
data$6.assistive_text;

var data$5 = { assistive_text: "Progression : %{progress}" };
data$5.assistive_text;

var data$4 = { assistive_text: "Avanzamento: %{progress}" };
data$4.assistive_text;

var data$3 = { assistive_text: "進行状況:%{progress}" };
data$3.assistive_text;

var data$2 = { assistive_text: "진행 상황: %{progress}" };
data$2.assistive_text;

var data$1 = { assistive_text: "Andamento: %{progress}" };
data$1.assistive_text;

var data = { assistive_text: "进度：%{progress}" };
data.assistive_text;

var locales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

const ANIMATION_DELAY = 250;
class progressBar extends LightningElement {
  @api progress = null;
  @api size = "medium";
  @api assistiveText = null;
  @api animation = "off";
  hasRendered = false;
  get className() {
    return classNames(`progress-bar progress-bar--${this.size}`, {
      "is-animated": this.animation === "on",
    });
  }
  get containerStyle() {
    return `
      --progress-min-width: ${this.progress ? "1em" : 0};
      min-width: 6rem;
    `;
  }
  get valueStyle() {
    return `width: ${this.progress}%`;
  }
  renderedCallback() {
    if (this.hasRendered) return;
    const delay = this.animation === "on" ? ANIMATION_DELAY : 0;

    // Apply styles, but delayed if animation is enabled
    setTimeout(() => {
      this.template
        .querySelector(".progress-bar__value")
        .setAttribute("style", this.valueStyle);
    }, delay);
  }

  // TODO l10n
  @wire(LabelsAdapter, {
    locales,
    options: "$labelOptions",
  })
  _labels = null;
  get labels() {
    return {
      ...this._labels,
      assistive_text: this.assistiveText || this._labels.assistive_text,
    };
  }
  get labelOptions() {
    return {
      assistive_text: {
        progress: this.progress || 0,
      },
    };
  }
}

export default progressBar;
